import { CVCompetenceTypesService } from "../../core/cvcompetencetypes.dataservice";
import { CVCompetenceGroupsService } from "../../core/cvcompetencegroups.dataservice";
import { CompetenceGroupsService } from "../../core/competencegroups.dataservice";
import { CompetenceTypeDataService } from "../../core/competencetypes.dataservice";
import { Ng2StateDeclaration } from "@uirouter/angular";
import { CvCompetenceTypes } from "./cv-competence-types.component";
import { EditCvCompetenceType } from "./cv-competence-type.edit.component";
import { CvCompetenceType } from "./cv-competence-type.component";

/**
 * This state displays all CV Competence Types
 */
export const cvCompetenceTypesState: Ng2StateDeclaration = {
    name: "app.settings.cvcompetencetypes",
    url: "/cvcompetencetypes",
    views: {
        "main-view@app": {
            component: CvCompetenceTypes
        }
    },
    resolve: {
        cvCompetenceTypes: [CVCompetenceTypesService.Id, (cvCompetenceTypeDataService: CVCompetenceTypesService) => {
            return cvCompetenceTypeDataService.getAll();
        }],
        cvCompetenceGroups: [CVCompetenceGroupsService.Id, function (cvCompetenceGroupService: CVCompetenceGroupsService) {
            return cvCompetenceGroupService.getAll();
        }]
    }
};

/**
 * This state is for creating a new CV Competence Type
 */
export const newCvCompetenceTypeState: Ng2StateDeclaration = {
    name: "app.settings.cvcompetencetypes.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: EditCvCompetenceType
        }
    },
    resolve: {
        cvCompetenceType: function () {
            return <Nema.Crew.Model.CompetenceTypeCVMapping>{
                Id: -1,
                Name: "",
                SortTag: "",
                InclusionMode: 0,
                NamingMode: 0,
                Active: true,
                CompetenceTypeCVMappingCompetenceGroups: [],
                CompetenceTypeCVMappingCompetenceTypes: []
            };
        },
        cvCompetenceGroups: [CVCompetenceGroupsService.Id, function (cvCompetenceGroupService: CVCompetenceGroupsService) {
            return cvCompetenceGroupService.getAll();
        }],
        competenceGroups: [CompetenceGroupsService.Id, function (competenceGroupService: CompetenceGroupsService) {
            return competenceGroupService.getAll();
        }],
        competenceTypes: [CompetenceTypeDataService.Id, function (competenceTypeService: CompetenceTypeDataService) {
            return competenceTypeService.getAll();
        }],
        isNew: function () {
            return true;
        }
    }
};

/**
 * This state is for editing a CV Competence Type
 */
export const editCvCompetenceTypeState: Ng2StateDeclaration = {
    name: "app.settings.cvcompetencetypes.edit",
    url: "/{id:int}/edit",
    views: {
        "main-view@app": {
            component: EditCvCompetenceType
        }
    },
    resolve: {
        cvCompetenceType: [CVCompetenceTypesService.Id, "$stateParams", function (cvCompetenceTypeDataService: CVCompetenceTypesService, $stateParams) {
            return cvCompetenceTypeDataService.get($stateParams.id);
        }],
        cvCompetenceGroups: [CVCompetenceGroupsService.Id, function (cvCompetenceGroupService: CVCompetenceGroupsService) {
            return cvCompetenceGroupService.getAll();
        }],
        competenceGroups: [CompetenceGroupsService.Id, function (competenceGroupService: CompetenceGroupsService) {
            return competenceGroupService.getAll();
        }],
        competenceTypes: [CompetenceTypeDataService.Id, function (competenceTypeService: CompetenceTypeDataService) {
            return competenceTypeService.getAll();
        }],
        isNew: function () {
            return false;
        }
    }
};

/**
 * CV Competence Type Details state
 */
export const cvCompetenceTypeState: Ng2StateDeclaration = {
    name: "app.settings.cvcompetencetypes.detail",
    url: "/{id:int}",
    views: {
        "main-view@app": {
            component: CvCompetenceType
        }
    },
    resolve: {
        cvCompetenceType: [CVCompetenceTypesService.Id, "$stateParams", function (cvCompetenceTypeDataService: CVCompetenceTypesService, $stateParams) {
            return cvCompetenceTypeDataService.get($stateParams.id);
        }],
        cvCompetenceGroups: [CVCompetenceGroupsService.Id, function (cvCompetenceGroupService: CVCompetenceGroupsService) {
            return cvCompetenceGroupService.getAll();
        }],
        competenceGroups: [CompetenceGroupsService.Id, function (competenceGroupService: CompetenceGroupsService) {
            return competenceGroupService.getAll();
        }],
        competenceTypes: [CompetenceTypeDataService.Id, function (competenceTypeService: CompetenceTypeDataService) {
            return competenceTypeService.getAll();
        }]
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/cvcompetencetypes/cv-competence-types.states.ts